/**
 * Discriminant returned by `POST api/google/auth` when the OAuth flow failed because
 * the user did not grant the Agenda scope (`calendar.app.created`). The status code
 * stays `417`; the body carries this reason so the frontend can show a specific,
 * actionable message instead of the opaque generic failure (#496).
 */
export const GOOGLE_AUTH_INSUFFICIENT_SCOPE = "insufficient_scope";
export const CGU_VERSION_CHANGED = "CGU_VERSION_CHANGED";
//# sourceMappingURL=account.model.js.map